import React from "react";
import { CloseModal } from "../../../assets/icons";
import "../../../styles/main.scss";

const Modalheader = ({ children, description, hide, hideShow }) => {
  return (
    <div className="rounded-t p-7">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h3 className="ft-lg tab:ft-2xl font-semibold text-[#202124]">
            {children}
          </h3>
          {description ? (
            <p className="mt-[6px] text-sm leading-relaxed text-gray-600">
              {description}
            </p>
          ) : null}
        </div>
        {hideShow ? (
          <button
            type="button"
            aria-label="Fermer"
            onClick={hide}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-transparent text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-workfully-600"
          >
            <CloseModal />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Modalheader;
